import React, { useEffect } from "react";
import { CommonHeader, ContentArea, ErrorSuccessModal, Loader } from "../../../components/commons";
import PerformanceEvaluationFormData from "../../../components/MySpace/PEFormModule/PerformanceEvaluationFormData";
import { connect } from "react-redux";
import { resetSession } from "../../../redux/auth";
import {
  addPerformanceEvaluationAction,
  resetMySpaceError,
  resetMySpaceMessage,
  resetMySpaceSuccess,
} from "../../../redux/mySpace";
import { RootState } from "../../../redux/rootReducers";
import { Toaster } from "react-hot-toast";
import { AddPerformanceEvaluationPayloadType } from "../../../commonTypes/mySpaceType";
import { emitNotification } from "../../../utils/commonFunctions";

type AppProps = {
  history: any;
  token: string | null;
  fetching: boolean;
  message: string | null;
  success: null | number;
  statusCode: null | number;
  error: null | string;
  dispatchAddPerformanceEvaluationAction: (data: AddPerformanceEvaluationPayloadType) => void;
  dispatchResetMySpaceSuccess: () => void;
  dispatchResetMySpaceMessage: () => void;
  dispatchResetMySpaceError: () => void;
  dispatchResetSession: () => void;
};
const AddPEForm = ({
  history,
  token,
  fetching,
  message,
  success,
  statusCode,
  error,
  dispatchAddPerformanceEvaluationAction,
  dispatchResetMySpaceSuccess,
  dispatchResetMySpaceMessage,
  dispatchResetMySpaceError,
  dispatchResetSession,
}: AppProps) => {
const [getManagerIdToNotification, setGetManagerIdToNotification] = React.useState<string | null>(null);
useEffect(()=>{
  dispatchResetMySpaceSuccess()
  dispatchResetMySpaceMessage()
  dispatchResetMySpaceError()

},[])

  const handleAddPerformanceEvaluation = (data: any) => {
  setGetManagerIdToNotification(data?.manager);
    if (token) {
      const finalData = {
        token,
        ...data,
      };
      dispatchAddPerformanceEvaluationAction(finalData);
    }
  };

   const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetMySpaceSuccess()
              dispatchResetMySpaceMessage()
              dispatchResetMySpaceError()
            }}
          />
        );
      }
    } else if (success === 1) {
      if (getManagerIdToNotification) {
        emitNotification( "notificationEvent",
             {receiver_id:String(getManagerIdToNotification)})
      }
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={success === 1}
          title="Success"
          message={"Performance Evaluation Form Added Successfully"}
          buttonText="OK"
          onPress={() => {
            history?.push({
              pathname: `/my-space/performance-evaluation-list`,
             state:{ activeTab:"myPe"}
            });
            dispatchResetMySpaceSuccess()
            dispatchResetMySpaceMessage()
            dispatchResetMySpaceError()
          }}
          statusCode={statusCode}
        />
      );
    }
    return false;
  };

  return (
    <div>
      <div className="col-md-6">
        <CommonHeader title="Add PE Form" />
      </div>

      <ContentArea>
        <PerformanceEvaluationFormData
          history={history}
          handleAddPerformanceEvaluation={handleAddPerformanceEvaluation}
        />
      </ContentArea>
      {handleErrorModal()}
      {fetching && <Loader />}
      <Toaster />
    </div>
  );
};


const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.mySpace.performanceEvaluationFetching,
  message: state.mySpace.message,
  success: state.mySpace.success,
  statusCode: state.mySpace.statusCode,
  error: state.mySpace.error,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchAddPerformanceEvaluationAction: (data: AddPerformanceEvaluationPayloadType) =>
    dispatch(addPerformanceEvaluationAction(data)),

  dispatchResetMySpaceSuccess: () => dispatch(resetMySpaceSuccess()),
  dispatchResetMySpaceMessage: () => dispatch(resetMySpaceMessage()),
  dispatchResetMySpaceError: () => dispatch(resetMySpaceError()),
  dispatchResetSession: () => dispatch(resetSession()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddPEForm);
